import { useIsMounted } from 'usehooks-ts';
import { useEffect } from 'react';
import { useAppDispatch } from '@/redux/store';
import { GeneralSlice } from '@/redux/general';

const logos = (() => {
  const logos = import.meta.glob<string>('@/assets/images/logo/*.svg', {
    eager: true,
    import: 'default',
  });
  return Object.entries(logos).reduce(
    (logoPaths, [filePath, component]) => {
      const fileNameWithExtension = filePath.split('/').pop() || '';
      const fileName = fileNameWithExtension.replace(/\.[^/.]+$/, '');
      switch (fileName) {
        case 'logo_raw':
          logoPaths.logo_raw = component;
          break;
        case 'logo_mobile_raw':
          logoPaths.logo_mobile_raw = component;
          break;
        case 'logo_rightmart':
          logoPaths.logo_rightmart = component;
          break;
      }
      return logoPaths;
    },
    {
      logo_raw: '',
      logo_mobile_raw: '',
      logo_rightmart: '',
    },
  );
})();

const useGetLogosFromAssets = () => {
  const dispatch = useAppDispatch();
  const isMounted = useIsMounted();

  useEffect(() => {
    if (!isMounted) return;
    dispatch(
      GeneralSlice.actions.setLogo({
        desktop: logos.logo_raw,
        mobile: logos.logo_mobile_raw,
        rightmart: logos.logo_rightmart,
      }),
    );
  }, [isMounted]);
};

export default useGetLogosFromAssets;
